export default __webpack_public_path__ + "static/media/0001.e1c0924f.svg";